import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { UploadStatus } from "../../redux/UploadEnums";
import { Badge } from "@mui/material";
import { Publish } from "@mui/icons-material";

export default function HeaderUploadIcon() {
  const queuedItems = useSelector(state => state.upload.uploadQueue).filter(
    x =>
      x.status === UploadStatus.PENDING ||
      x.status === UploadStatus.UPLOADING ||
      x.status === UploadStatus.PAUSED
  ).length;

  const errorQueueItems = useSelector(state => state.upload.uploadQueue).filter(
    x => x.status === UploadStatus.ERROR
  ).length;

  return (
    <div className="headerMenuItem" style={{ marginRight: "15px" }}>
      <Link to={"/uploads"}>
        {errorQueueItems > 0 ? (
          <Badge badgeContent="!" color="secondary">
            <Publish className="headerMenuMail" />
          </Badge>
        ) : queuedItems > 0 ? (
          <Badge badgeContent={queuedItems} color="primary">
            <Publish className="headerMenuMail" />
          </Badge>
        ) : (
          <Publish className="headerMenuMailFaded" />
        )}
      </Link>
    </div>
  );
}
